import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'

const CommunitiesWebsiteContext = createContext()

const CommunitiesWebsiteProvider = ({ children }) => {
   const [contactModalOptions, setContactModalOptions] = useState({
      open: false,
      reason: null
   })

   return (
      <CommunitiesWebsiteContext.Provider value={{ contactModalOptions, setContactModalOptions }}>
         {children}
      </CommunitiesWebsiteContext.Provider>
   )
}

CommunitiesWebsiteProvider.propTypes = {
   children: PropTypes.node.isRequired
}

export {
   CommunitiesWebsiteProvider,
   CommunitiesWebsiteContext
}
